export const GET_LIST_CONF_CATALOGOS_LOADING =
  'configuracionCatalogos/GET_LIST_CONF_CATALOGOS_LOADING';
export const GET_LIST_CONF_CATALOGOS_SUCCESS =
  'configuracionCatalogos/GET_LIST_CONF_CATALOGOS_SUCCESS';
export const GET_LIST_CONF_CATALOGOS_FAILURE =
  'configuracionCatalogos/GET_LIST_CONF_CATALOGOS_FAILURE';

export const UPDATE_CONF_CATALOGOS_LOADING = 'configuracionCatalogos/UPDATE_CONF_CATALOGOS_LOADING';
export const UPDATE_CONF_CATALOGOS_SUCCESS = 'configuracionCatalogos/UPDATE_CONF_CATALOGOS_SUCCESS';
export const UPDATE_CONF_CATALOGOS_FAILURE = 'configuracionCatalogos/UPDATE_CONF_CATALOGOS_FAILURE';

// export const GET_LIST_TIPOS_MI_LOADING = 'tiposMediosImpresos/GET_LIST_TIPOS_MI_LOADING';
// export const GET_LIST_TIPOS_MI_SUCCESS = 'tiposMediosImpresos/GET_LIST_TIPOS_MI_SUCCESS';
// export const GET_LIST_TIPOS_MI_FAILURE = 'tiposMediosImpresos/GET_LIST_TIPOS_MI_FAILURE';

// export const UPDATE_TIPOS_MI_LOADING = 'tiposMediosImpresos/UPDATE_TIPOS_MI_LOADING';
// export const UPDATE_TIPOS_MI_SUCCESS = 'tiposMediosImpresos/UPDATE_TIPOS_MI_SUCCESS';
// export const UPDATE_TIPOS_MI_FAILURE = 'tiposMediosImpresos/UPDATE_TIPOS_MI_FAILURE';

// export const GET_LIST_TIPOS_HALLAZGOS_LOADING = 'tiposHallazgos/GET_LIST_TIPOS_HALLAZGOS_LOADING';
// export const GET_LIST_TIPOS_HALLAZGOS_SUCCESS = 'tiposHallazgos/GET_LIST_TIPOS_HALLAZGOS_SUCCESS';
// export const GET_LIST_TIPOS_HALLAZGOS_FAILURE = 'tiposHallazgos/GET_LIST_TIPOS_HALLAZGOS_FAILURE';

// export const UPDATE_TIPOS_HALLAZGOS_LOADING = 'tiposHallazgos/UPDATE_TIPOS_HALLAZGOS_LOADING';
// export const UPDATE_TIPOS_HALLAZGOS_SUCCESS = 'tiposHallazgos/UPDATE_TIPOS_HALLAZGOS_SUCCESS';
// export const UPDATE_TIPOS_HALLAZGOS_FAILURE = 'tiposHallazgos/UPDATE_TIPOS_HALLAZGOS_FAILURE';
